import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Scroll_to_Top = () => {
  const { pathname } = useLocation();
  window.scrollTo({ top: 0, behavior: "auto" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default Scroll_to_Top;
